import { ChangeDetectionStrategy, Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Component({
  selector: 'app-html-formatter',
  standalone: true,
  templateUrl: './html-formatter.component.html',
  styleUrls: ['./html-formatter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HtmlFormatterComponent implements OnChanges {
  @Input() htmlText: string;
  html: SafeHtml | null;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    this.html = null;
    if (changes['htmlText'] && this.htmlText) {
      // Use DOMPurify to sanitize the HTML while preserving styles
      // Avoid hackers from inserting attributes
      const cleanHtml = DOMPurify.sanitize(this.htmlText, {
        ADD_TAGS: ['video'],
        ALLOWED_ATTR: ['style', 'class', 'href', 'target', 'rel', 'src', 'width', 'height', 'download', 'controls', 'preload', 'playsinline', 'colspan', 'rowspan', 'data-list', 'data-language', 'spellcheck'],
        ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix|blob):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
      });
      this.html = this.sanitizer.bypassSecurityTrustHtml(this.withVideoControls(cleanHtml));
    }
  }

  withVideoControls(html: string): string {
    const container = document.createElement('div');
    container.innerHTML = html;
    container.querySelectorAll('video').forEach((video) => {
      video.setAttribute('controls', 'true');
      video.setAttribute('playsinline', 'true');
      if (!video.getAttribute('preload')) {
        video.setAttribute('preload', 'metadata');
      }
    });
    return container.innerHTML;
  }
}
